import debounce from '~/utils/events/debounce';
import {setLoading} from '../Store/creators/common';
import {setFilter} from '../Store/creators/filter';
import {setBuilding} from '../Store/creators/visualData';
import {dispatch} from '../Store/index';
import {StateVisualBuilding} from '../Store/State';
import sendVisualRequest from '../utils/sendVisualRequest';

// tslint:disable:max-line-length
const data = {
	front: {
		1: {
			building: '1',
			view: 'front',
			nextView: '',
			image: '/images/choose-visual/building/01.jpg?2',
			map: [
				{
					path: 'M170.197 345.723L174.385 385.148L176.94 386.342L178.795 403.665L176.593 405.457L178 418.599L169.598 423.975L170.367 431.149L188.148 597.203L377 678.5L374.675 635.165L371.689 633.909L363 486.5L366 484L365 457L365.99 454.635L365 420L372.262 414.5V418.5L455.5 356.5V342.5L463.829 335.934L441.583 327.407L434.5 332.909V299.5H432V291L418.5 301.5L408 297.685V290L338.5 265L332 270L295.256 256.719L283.667 265.352L278.068 263.19L255.165 279.418V291.667L245.854 298.262L240.262 296.095L216.58 312.869L216.516 319.042L203.545 328.229L197.943 326.071L170.197 345.723Z',
					target: '1.1',
					available: 1,
				},
				{
					path: 'M365 420L372.262 414.5V418.5L455.5 356.5V342.5L463.829 335.934L471.112 330.276L496 339.817L504.5 333.421L519.181 339L528.5 331.76L591.5 355.592V372.19L602.89 363.341L634.53 375.47L635.128 386.94L639.317 388.396L637 389.5V398.124L593.894 435.5L589.97 435L577.748 445.424V449.5L575.5 451.449L572.383 450L560 460.561V464.889L534.5 487V486L531.5 484.868L529 487V522.5L533 524.136V551.5L530.5 554.5L532.5 701.816L536 703.292L537.598 747.741L377 678.5L374.675 635.165L371.689 633.909L363 486.5L366 484L365 457L365.99 454.635L365 420Z',
					target: '1.2',
					available: 1,
				},
				{
					path: 'M529 522.5L533 524.136V551.5L530.5 554.5L532.5 701.816L536 703.292L537.598 747.741L651.284 796.715L700.35 747.135L701.5 639.5L704 638.5V608.5L705.5 609L706 556.5L716.5 546.901V556.5L740 533V525.417L751 515.36C753 515.36 753.572 518.787 753.608 520.5L783 493.5V486.105L791.866 478C795.573 477.2 798.79 477.667 799.935 478L812.5 466.5V452.532L815.336 450.664L809.469 448.465L806.86 450.855L787.953 443.687V432.337L761.982 422.605V418.572L695.091 393.505L688.407 399.065L658.717 387.938L652.31 392.913L639.317 388.396L637 389.5V398.124L593.894 435.5L589.97 435L577.748 445.424V449.5L575.5 451.449L572.383 450L560 460.561V464.889L534.5 487V486L531.5 484.868L529 487V522.5Z',
					target: '1.3',
					available: 1,
				},
				{
					path: 'M706 556.5L716.5 546.901V556.5L740 533V525.417L751 515.36C753 515.36 753.572 518.787 753.608 520.5L783 493.5V486.105L791.866 478C795.573 477.2 798.79 477.667 799.935 478L812.5 466.5V452.533L815.336 450.664L831.174 456.599L840.809 448.113L910.292 474.151V487.89L927.73 494.461V499.24L932.205 494.461L963.098 506.038L962.5 522L904.5 579.5L900.495 575.5L882 593.779V602L865 619.5V610.582L858 617.5L855.513 677.675L860.832 680L851.892 831.092L845.932 834L843 832.764L841 876L699.154 814.635L700.35 747.135L701.5 639.5L704 638.5V608.5L705.5 609L706 556.5Z',
					target: '1.4',
					available: 1,
				},
				{
					path: 'M858 617.5L865 610.581V619.5L882 602V593.779L900.495 575.5L904.5 579.5L962.5 522L963.098 506.038L983.768 513.784L994.149 504.018L1048 523.892L1065.35 530.516L1063.51 558.973L1110.5 576.932V587.5L1025 680V676L1018 681L1015.09 716.477L1018.27 717.75L1016.76 742.503L1016.5 746L1011 749L998.244 898.235L1000.06 899L997.5 943.5L841 876L843 832.764L845.932 834L851.892 831.092L860.832 680L855.513 677.675L858 617.5Z',
					target: '1.5',
					available: 1,
				},
				{
					path: 'M1018 681L1015.09 716.477L1018.27 717.75L1016.76 742.503L1016.5 746L1011 749L998.244 898.235L1000.06 899L997.5 943.5L1236.49 1047L1338.81 914.391L1341.61 886L1344.69 882.012L1345.39 876.758L1369.68 737.5L1365.58 735.302L1371.5 689L1374 686.048L1383 622.5L1210.56 558.913L1207.62 587.323L1189.5 580.5L1186.5 583.5L1171.5 599V614L1146 604.5V590.5L1110.5 576.932V587.5L1025 680V676L1018 681Z',
					target: '1.6',
					available: 1,
				},
				{
					path: 'M1428.5 521.5L1453.5 531.5L1450 558L1452.5 559L1452 571L1449.5 599L1455 592L1451.5 631L1453.64 632.5L1424.62 802.5L1362 883.5L1345.39 876.758L1369.68 737.5L1365.58 735.302L1371.5 689L1374 686.048L1383 622.5L1210.56 558.913L1221.96 546.412L1222.07 545.337C1223.49 531.518 1225.14 515.58 1226.33 503.857L1263 464L1341 493V505L1419.5 532.5V527L1422.5 525L1428.5 527V521.5Z',
					target: '1.7',
					available: 1,
				},
				{
					path: 'M1453.5 531.5L1428.5 521.5V527L1422.5 525L1419.5 527V532.5L1341 505V493L1265.5 464.93L1280.5 448.5L1294.61 453.5L1301.36 446.102L1302.52 434.756L1316.65 419.267L1318.31 403.01L1344.77 374L1348.5 375.5V380L1415.5 404L1418.5 401L1422 402.5V422L1492 443V437L1506 441.5V436L1530.5 446L1528 502.5L1531 504V525.5L1527 529L1533.81 531L1503 701.533L1424.62 802.5L1453.64 632.5L1451.5 631L1455 592L1449.5 599L1452 571L1452.5 559L1450 558L1453.5 531.5Z',
					target: '1.8',
					available: 1,
				},
				{
					path: 'M1580.55 302.715L1635.6 321.232L1627.22 358.865L1618.84 369.617L1617.67 376.062C1617.96 374.735 1619.84 373.798 1621.24 373.798C1621.7 373.798 1622.19 373.642 1622.68 373.49C1624.1 373.045 1625.43 372.629 1625.43 376.187C1625.43 377.872 1625.05 381.262 1624.52 385C1623.54 391.867 1622.01 399.905 1621.24 400.678C1620.28 401.634 1618.84 401.475 1618.25 401.276L1615.85 413.223L1609 424L1616.45 426.364L1585.34 570.323L1584.14 572.115L1579.35 603.176L1503 701.532L1533.81 531L1527 529L1531 525.5V504L1528 502.5L1530.5 446L1506 436V441.5L1492 437V443L1422 422V402.5L1418.5 401L1415.5 404L1348.5 380V375.5L1344.77 374L1334.5 385.264L1336.42 369L1333 372L1337.5 332.5L1350 320.5V324L1403.5 272.5V267.5L1407.5 264.073V258L1418.5 247.186L1420.19 247.759V256.504L1442.33 264.073L1450.11 256.122L1481.22 266.874V273.173L1507.55 282.174L1512.33 277.396L1544.65 288.443V299.056L1574.53 309.275L1580.55 302.715Z',
					target: '1.9',
					available: 1,
				},
				{
					path: 'M1385.87 244.773L1392.06 238.202L1418.5 247.186L1407.5 258V264.073L1403.5 267.5V272.5L1350 324V320.5L1337.5 332.5L1333 372L1336.42 369L1334.5 385.264L1318.31 403.01L1316.65 419.267L1302.52 434.756L1301.36 446.101L1294.61 453.5L1280.5 448.5L1265.5 464.93L1263 464L1226.33 503.857L1221.96 546.412L1210.56 558.913L1207.62 587.323L1189.5 580.5L1186.5 583.5L1119.21 560.168L1119.81 550.611L1065.35 530.516L1048 523.892L1065.95 330.79L1067.75 330.192C1067.35 327.803 1067.27 322.905 1070.14 320.038L1071.34 290.768C1070.85 289.539 1070.96 286.895 1071.27 284C1071.45 282.227 1071.71 280.359 1071.95 278.665C1072.26 276.403 1072.53 274.45 1072.53 273.445C1072.53 271.056 1074.53 269.264 1075.53 268.666L1077.92 228.644L1093.48 213.711L1106.04 217.892V201.764L1122.2 186.831L1136.56 191.609L1161.09 167.118L1188.02 176.676L1191.61 174.156L1219.13 183.567V194.391L1238.28 201.167L1247.26 193.182L1276.27 203.101V207.298L1301.71 215.997L1304.7 212.822L1333.42 222.642L1335.82 220.282L1362.74 229.507V236.864L1385.87 244.773Z',
					target: '1.10',
					available: 1,
				},
				{
					path: 'M642.309 125.902L639.915 124.707V106.5C633.986 104.195 627.23 101.568 620 98.7554V103L615 101.5V110.5L581 97.6005V94.5L570 90.5L566.5 92.0993L518 73.6986V70L515.455 68.5574L504.672 75.8514L496.62 72.1983L478.835 84.8866V91.1979L465.18 100.94L459.208 98.1883L435.752 115.15V119.016L423.785 127.554V133.184L413.72 140.364L423 144V157.852L491 182.267V177L495.5 173.557L510 178.658V189.089L519.5 192.5V181.551L541.5 190L541.5 218L545 216L548.814 218V253.267L543 257.581V268L546.5 266.5L548.814 268V291.115L549.135 302.754L550.16 339.954L591.5 355.592V372.19L602.89 363.341L629.767 373.644L638.276 366.611L636.278 233.939L636.021 216.883L640.5 213.5L642 131L642.309 125.902Z',
					target: '1.11',
					available: 1,
				},
				{
					path: 'M405.903 136.763L413.72 140.364L423 144V157.852L491 182.267V177L495.5 173.557L510 178.658V189.089L519.5 192.5V181.551L541.5 190V218L545 216L548.814 218L548.814 253.267L543 257.581L543 268L546.5 266.5L548.814 268V291.115L550.16 339.954L528.5 331.76L519.181 339L504.5 333.421L496 339.817L471.112 330.276L463.829 335.934L441.583 327.407L434.5 332.909V299.5H432V291L418.5 301.5L408 297.685V290L338.5 265L332 270L295.256 256.72L293.46 221.476L326.891 197.495L329.949 198.904L349.587 184.893V177.273L374.24 159.76L382.426 163.532L387.883 159.639V150.393L405.903 136.763Z',
					target: '1.12',
					available: 1,
				},
			],
		},
		2: {
			building: '2',
			view: 'front',
			nextView: '',
			image: '/images/choose-visual/building/02.jpg?2',
			map: [
				{
					path: 'M367.411 199.041L388.356 178.647L401.034 179.749L408.75 172.032L407.097 159.906L429.696 139.512L455.604 144.25L456.303 148.867L652.585 181.01L672.221 322.633L678.453 367.577L931.264 415.12L937.5 416.5L937.346 427.5L1031 446L1034.36 441.99L1038.21 442.995L1054.83 606.925L998.528 682.989L958.764 674.782L956.086 657.083L861.842 636.717L850.808 651.571L831.517 647.162L830.414 640.547L791.427 631.936L790.728 627.319L754.901 620.153L754.085 614.767L698.679 603.617L697.98 599L646.866 589.155L642.358 555.643L627.575 552.907L593.108 589.155L558.254 386.447L557.022 379.281L559.778 376.525L543.082 258.541L539.771 257.467L537.04 239.423C533.209 238.562 529.373 237.754 525.345 236.905L525.342 236.905L525.34 236.904C520.74 235.936 515.89 234.914 510.511 233.7L511.472 240.054L505.761 238.727L507.366 249.334L461.114 240.931L460.563 235.42L448.988 229.908L440.852 233.258V237.073L376.23 226.049L375.128 215.025L369.064 219.986L367.411 199.041Z',
					target: '2.1',
					available: 1,
				},
				{
					path: 'M1122.38 309.852L1127.1 361.874C1125.94 362.838 1123.72 365.534 1124.19 368.612C1124.34 369.651 1124.5 371.437 1124.68 373.562C1124.91 376.18 1125.18 379.312 1125.56 382.196C1126.01 385.636 1126.6 388.723 1127.45 390.158L1130.19 429.099C1127.05 433.351 1128.23 440.415 1129.21 443.416L1126.78 442.995L1130.57 504.604L1054.83 606.925L1038.21 442.996L1034.36 441.99L1030.5 446L937.5 427.5V416.5L931.264 415.12L1101.39 207.555L1179.12 219.407L1209.41 224.269L1190.58 250.731L1171.18 247.37L1153.31 269.752L1156.46 290.528L1139.48 287.587L1122.38 309.852Z',
					target: '2.2',
					available: 1,
				},
			],
		},
		3: {
			building: '3',
			view: 'front',
			nextView: '',
			image: '/images/choose-visual/building/03.jpg?2',
			map: [
				{
					path: 'M821.237 85.0359L814.058 92.0213L784.752 85.6497L783.955 74.6517L750.076 67.382L741.064 76.1513L713.536 70.1662L712.739 59.1682L679.504 51.9423L676.659 54.7109L638.507 46.2124L618.681 64.2377L619.155 71.7567L558.998 128.392L557.456 170.427L553.438 173.196L552.573 212.673L554.349 214.238L554.258 239.407L550.24 242.177L549.782 261.497L538.616 270.589L530.748 445.547L562.732 453.596L572.122 442.938L610.549 453.936L615.338 450.096L654.587 460.835L655.541 475.975L682.865 483.766L694.689 471.808L736.056 483.127L736.426 488.998L742.5 490.66L754 322L758.5 320.5L746.5 317.5L753 173.5L767.673 156.5V163.5L816.976 106.5V99.3752L828 86.6028L821.237 85.0359Z',
					target: '3.1',
					available: 1,
				},
				{
					path: 'M1198.75 154.318L1187.68 151.66L1178.5 162.5L1148.31 156.165L1141.15 163.135L1114.62 157.368L1113.82 146.37L1084.06 139.898L1074.96 148.746L1046.62 142.583L1045.82 131.585L1005.95 122.918L996.862 131.765L971.778 126.312L970.982 115.314L934.45 107.371L925.358 116.219L895.266 109.677L894.469 98.679L860.18 91.2238L857.827 93.5127L828 86.6025L816.976 99.375V106.5L767.673 163.5V156.5L753 173.5L746.5 317.5L758.5 320.5L754 322L742.5 490.66L772.704 498.925L776.6 494.221L817.555 505.428L820.688 501.916L859.086 512.449L859.734 522.738L892.719 531.764L900.777 522.029L940.874 532.922L941.645 545.151L973.215 553.79L983.382 541.984L1027.75 554.284L1028.31 563.094L1065.85 573.367L1072.11 566.262L1088.32 570.698L1097.69 490.732L1098.13 486.94L1100.48 484.275L1102.44 484.704L1106.43 485.578L1127.4 459.093L1128.16 452.047L1130.05 434.602L1131.61 432.825L1134.96 432.615L1155.93 406.13L1155.77 403.623L1159.45 400.036L1161.4 399.913L1185.1 217.246L1191.42 210.977L1198.75 154.318Z',
					target: '3.2',
					available: 1,
				},
			],
		},
	},
};

async function fetchVisualBuilding( building: string, view: string ): Promise<void>
{
	if ( !( view in data ) )
	{
		// tslint:disable-next-line:no-parameter-reassignment
		view = 'front';
	}
	
	const viewData = {...(data as any)[view][building]} as StateVisualBuilding;
	
	dispatch( setLoading( true ) );
	
	const serverData = await sendVisualRequest( {buildingView: view, building} );
	
	if ( serverData.building && serverData.building.map )
	{
		const sections = new Map<string | number, number>();
		
		for ( const item of serverData.building.map )
		{
			sections.set( item.target, item.available );
		}
		
		for ( const item of viewData.map )
		{
			if ( sections.has( item.target ) )
			{
				// tslint:disable-next-line:no-non-null-assertion
				item.available = sections.get( item.target )!;
			}
			else
			{
				item.available = 0;
			}
		}
	}
	
	// TODO:
	dispatch(
		setFilter( serverData.filter ),
	);
	
	dispatch( setBuilding( viewData ) );
	
	dispatch( setLoading( false ) );
}

const debouncedFetchVisualBuilding = debounce( fetchVisualBuilding, 200 );

/**
 * Module.
 */
export {
	fetchVisualBuilding as default,
	debouncedFetchVisualBuilding,
};



// WEBPACK FOOTER //
// ./app/Routes/Choose/App/asyncActions/fetchVisualBuilding.ts